import MatTable from "./Table/MatTable";
import { useMemo, useState, useEffect } from "react";
import { Alert, Flex, Select, Spin, select } from 'antd';

import { inkapi } from "../middleware/interceptor";


const PrintOrders = () => {


  const [activeCommentRowId, setActiveCommentRowId] = useState(null);
  const [comment, setComment] = useState('');
  const [rowComments, setRowComments] = useState({});

  const [tableData, setTableData] = useState([]);
  const [editingRowIndex, setEditingRowIndex] = useState(null);
  const [editedRowData, setEditedRowData] = useState({});

  const [Loading, setloading] = useState(false);

  const validateRequired = (value) => !!value.length;


  const options = [{ label: "Guided", value: 1 }, { label: "DIY", value: 2 }, { label: "Published", value: 3 }, { label: "Print Orders", value: 4 }, { label: "Submitted", value: 5 }]

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        size: 50,
        // cell: (row ) => row.index + 1
        enableEditing: false,

        Cell: ({ row }) => row.index + 1
      },
      {
        accessorKey: "oppid",
        header: "Opp ID",
        size: 50,
        Cell: ({ cell }) => cell.getValue() || "-",
        enableEditing: false,

      },
      {
        accessorKey: "BookId",
        header: "Book ID",
        size: 50,
        enableEditing: false,


      },
      {
        accessorKey: "AuthorId",
        header: "Author ID",
        size: 50,
        enableEditing: false,

      },
      {
        accessorKey: "Name",
        header: "Name",
        enableEditing: false,
        Cell: ({ row }) =>
          row.original.Name
      },
      {
        accessorKey: "Title",
        header: "Title",
        Cell: ({ cell }) => cell.getValue() || "-",
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: 'text',
          required: true,
          // error: !!validationErrors?.[cell.id],
          // helperText: validationErrors?.[cell.id],
          //store edited user in state to be saved later
          onBlur: (event) => {

            setEditedRowData({ ...editedRowData, Title: event.target.value })
            console.log("evenr", event.target.value);
            const validationError = !validateRequired(event.currentTarget.value)
              ? 'Required'
              : undefined;
            handleSave(row.original.BookId, event.target.value)
          },
        }),
      },
      // {
      //   accessorKey: "comments",
      //   header: "Comment",
      //   Cell: ({ row }) => {
      //     const bookId = String(row.original.BookId);
      //     const isEditing = activeCommentRowId == bookId;
      //     // const [comment, setComment] = useState("");

      //     return isEditing ? (
      //       <div style={{ display: "flex", gap: "8px" }}>
      //         <input
      //           type="text"
      //           value={comment || row.original.comments}
      //           placeholder="Add comment"
      //           onChange={(e) => setComment(e.target.value)}
      //           style={{
      //             padding: "2px 8px",
      //             borderRadius: "4px",
      //             border: "1px solid #ccc",
      //           }}
      //         />
      //         <button
      //           onClick={() => { handleSavecomments(bookId, comment); setComment('') }}
      //           style={{
      //             padding: "2px 10px",
      //             backgroundColor: "#007bff",
      //             color: "white",
      //             border: "none",
      //             borderRadius: "4px",
      //             cursor: "pointer",
      //           }}
      //         >
      //           Save
      //         </button>
      //       </div>
      //     ) : row.original.comments == null || row.original.comments == "" ? (
      //       <button
      //         onClick={() => {
      //           setActiveCommentRowId(bookId);
      //           setRowComments((prev) => ({
      //             ...prev,
      //             [bookId]: row.original.comments || "",
      //           }));
      //         }}
      //         style={{
      //           padding: "2px 10px",
      //           backgroundColor: "white",
      //           color: "#444",
      //           border: "1px solid #ccc",
      //           borderRadius: "4px",
      //           cursor: "pointer",
      //         }}
      //       >
      //         Add Comments
      //       </button>
      //     ) : (
      //       row.original.comments
      //     );
      //   },
      // },
      
      {
        accessorKey: "package",
        header: "Package",
        size: 100,
        enableEditing: false,
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        accessorKey: "interior",
        header: "Interior",
        enableEditing: false,
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        accessorKey: "cover",
        header: "Cover",
        enableEditing: false,
        size: 100,
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        accessorKey: "paymentMade",
        header: "Payment Made",
        enableEditing: false,
        size: 50,
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      {
        accessorKey: "paymentPending",
        header: "Payment Pending",
        enableEditing: false,
        size: 50,
        Cell: ({ cell }) => cell.getValue() || "-",
      },
      // {
      //   accessorKey: "status",
      //   header: "Status",
      //   size: 100,
      //   enableEditing: false,
      //   Cell: ({ cell }) => cell.getValue() || "-",
      // },

    ], [editingRowIndex, editedRowData, activeCommentRowId, comment]);




  const handleEditRow = (row) => {
    setEditingRowIndex(row.index);
    setEditedRowData(row.original);
  };


  const handleSaveComment = async (rowId, comment) => {
    console.log(rowId, comment, "dataaa")
    try {
      const response = await inkapi.post("/api/savecomment", {
        id: rowId,
        comment: comment,
      });
      if (response.data.success) {
        console.log("Comment saved!");
      }
    } catch (err) {
      console.error("Failed to save comment:", err);
    }
  };

  const handleSave = async (index, title) => {
    try {

      const updatedRow = editedRowData;
      console.log("updatedRow", updatedRow);
      // const [firstName, lastName] = updatedRow.Name.split(" ") || "";
      const payload = {
        BookId: index,
        FirstName: "firstName",
        LastName: "lastName",
        Title: title
      };

      const response = await inkapi.post('/api/editedbookdetails', payload);

      console.log(response.data, "Data")
      if (response.data.message == "Book details updated successfully") {
        const updatedData = [...tableData];
        updatedData[index] = updatedRow;
        // setTableData(updatedData);
        setEditingRowIndex(null);
        setEditedRowData({});
        await GetDetails();
      } else {
        console.error("Failed to save:", response.data.message);
      }
    } catch (err) {
      console.error("API error while saving row:", err);
    }
  };


  const handleSavecomments = async (bookId, comment) => {


    console.log(comment, 'rowComments')
    try {

      const payload = {
        BookId: activeCommentRowId,
        Comments: comment
      };

      const response = await inkapi.post('/api/comments', payload);
      if (response.data.success) {
        setActiveCommentRowId(null);
        setComment('');
        await GetDetails()
      } else {
        console.error("Failed to save:", response.data.message);
      }
    } catch (err) {
      console.error("API error while saving row:", err);
    }
  };



  useEffect(() => {
    GetDetails()
  }, []);



  const GetDetails = async () => {

    setloading(true);
    await inkapi.get(`api/getbookdetails/${"Submitted"}`)
      .then((res) => {
        const result = res.data;
        console.log("API Raw:", res.data.data);
        if (result.success) {
          const mappedData = result.data.map((item) => ({
            BookId: item.BookId,
            AuthorId: item.AuthorId,
            Name: `${item.FirstName} ${item.LastName}`,
            Title: item.Title,
            comments: item.Comment,
            oppid: item?.Opportunities,
            status: item.bookStatus
          }));
          setTimeout(() => {
            setloading(false);
          }, 1000);
          console.log(mappedData, "data")
          setTableData(mappedData);
        }
      })
      .catch((err) => console.error("Failed to fetch package values:", err));
  }

  return (
    <div className="material_wrapper">

      {
        Loading ? (
          <div>
            <Spin tip="Loading" size="medium">
              <MatTable columns={columns} data={tableData} />
            </Spin>
          </div>


        ) : (
          <>
            <MatTable columns={columns} data={tableData} />

          </>)
      }

    </div>
  );
};
export default PrintOrders;
